import { Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { AppModule } from '../../app.module';
import { NotificationService } from '../../shared/notification.service';
import { LocationService } from '../../shared/location.service';
import { Globals } from '../../shared/functions';

@Component({
  selector: 'app-map-navigation',
  imports: [AppModule],
  templateUrl: './map-navigation.html',
  styleUrl: './map-navigation.less'
})
export class MapNavigation implements OnInit {

  @Input({ required: true }) destination!: google.maps.LatLngLiteral; //The destination coordinates

  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef; 
  @ViewChild('directionsPanel', { static: true }) directionsPanel!: ElementRef;

  map?: google.maps.Map;
  directionsService?: google.maps.DirectionsService;
  directionsRenderer?: google.maps.DirectionsRenderer;

  public directionsResults?: google.maps.DirectionsResult; //Store directionresults, used for html display logic

  constructor(private zone: NgZone, public notification: NotificationService, private locationService: LocationService) {} //Needs to be updated for zoneless app

  ngOnInit(): void {
    this.initializeMap();
  }

  private initializeMap(): void {
    // Get the user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation: google.maps.LatLngLiteral = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          //This will calculate the driving time and distance, as a temp
          this.locationService.calculateDrivingTimeAndLength(userLocation, this.destination).then(result => {
            if (result) {
              console.log('Driving time:', Globals.Functions.formatDuration(result.duration));
              console.log('Driving distance:', Globals.Functions.formatDistance(result.distance));
            }
          });

          // Run inside NgZone to ensure UI updates
          this.zone.run(() => {
            // Create map centered on the user's location
            const mapOptions: google.maps.MapOptions = {
              center: userLocation,
              zoom: 15,
            };
            this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

            // Initialize Directions Service and Renderer
            this.directionsService = new google.maps.DirectionsService();
            this.directionsRenderer = new google.maps.DirectionsRenderer();
            
            // Bind the renderer to the map and directions panel
            this.directionsRenderer.setMap(this.map);
            this.directionsRenderer.setPanel(this.directionsPanel.nativeElement);

            // Calculate and display the route
            this.calculateAndDisplayRoute(userLocation);
          });
        },
        (error) => {
          this.notification.showError('Geolocation failed: ' + error.message);
        }
      );
    } 
    else {
      this.notification.showError('Geolocation is not supported by this browser.');
    }
  }

  private calculateAndDisplayRoute(origin: google.maps.LatLngLiteral): void {
    if (!this.directionsService || !this.directionsRenderer) {
      return;
    }
    
    // Create the directions request
    const request: google.maps.DirectionsRequest = {
      origin: origin,
      destination: this.destination,
      travelMode: google.maps.TravelMode.DRIVING, // We seriously hope that a technician is driving...
    };

    // Call the Directions Service
    this.directionsService.route(request, (result, status) => {
      this.zone.run(() => {
        if (status === 'OK' && result) {
          // Render the route on the map and the directions in the panel
          this.directionsRenderer?.setDirections(result);
          this.directionsResults = result;
        }
        else {

          this.notification.showError('Failed to calculate route: ' + status);
        }
      });
    });
  }

}
